import React, { memo } from 'react';
import PropTypes from 'prop-types';

const Shimmer = memo(({ width, height, classNames }) => (
    <div
        style={{ width: width, height: height }}
        className={`shimmer ${classNames}`}
    />
));

Shimmer.propTypes = {
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    classNames: PropTypes.string
};

export default Shimmer;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/shimmer/shimmer.jsx